import React from 'react';

const WhatsaAppContext = React.createContext()

export default WhatsaAppContext